import axios from 'axios';
import { useAuthStore } from './auth-store';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

function addAuthInterceptors(instance: ReturnType<typeof axios.create>) {
  instance.interceptors.request.use((config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        useAuthStore.getState().logout();
      }
      throw error;
    },
  );
  return instance;
}

export const api = addAuthInterceptors(
  axios.create({
    baseURL: `${API_URL}/api/v1/admin`,
    headers: { 'Content-Type': 'application/json' },
  }),
);

export const changelogApi = addAuthInterceptors(
  axios.create({
    baseURL: `${API_URL}/api/v1/changelog`,
    headers: { 'Content-Type': 'application/json' },
  }),
);

export const blogApi = addAuthInterceptors(
  axios.create({
    baseURL: `${API_URL}/api/v1/blog`,
    headers: { 'Content-Type': 'application/json' },
  }),
);

export const voiceApi = addAuthInterceptors(
  axios.create({
    baseURL: `${API_URL}/api/v1/voice`,
    headers: { 'Content-Type': 'application/json' },
  }),
);

export const voiceComplianceApi = addAuthInterceptors(
  axios.create({
    baseURL: `${API_URL}/api/v1/voice-compliance`,
    headers: { 'Content-Type': 'application/json' },
  }),
);
